<template>
    <el-container>
        <el-header>
            <h1>趣头条定向包</h1>
        </el-header>
        <el-main>
            <el-row>
                <el-col :span="8">
                    <div class="grid-content bg-purple" style="display: flex;">
                        <el-input placeholder="请输入定向" v-model="input" style="width: 250px;" clearable></el-input>
                        <div style="margin-left: 10px;"><el-button type="primary" @click="selectdxb">查询</el-button></div>
                        <div style="margin-left: 30px;"><el-button type="primary" @click="opendialog">新建定向</el-button></div>
                    </div>
                </el-col>
                <el-col :span="4">
                </el-col>
                <el-col :span="12">
                </el-col>
            </el-row>
            <el-table ref="multipleTable" :data="dingxiangbaoData" stripe style="width: 100%;margin-top: 30px;">
                <el-table-column type="pkgname" prop="pkgname" label="定向包名">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="editdxbao(scope.row)">修改</el-button>
                        <el-popconfirm title="确定删除吗？" confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info"
                            icon-color="red" @confirm="deletedxb(scope.row)">
                            <el-button slot="reference" type="danger">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>

            </el-table>

        </el-main>
        <el-dialog title="上传创意素材" :visible.sync="creativeMaterials" width="1160px" append-to-body @close="closebiaodan">
            <div class="m-header" style="height: 550px;overflow-y: auto;">
                <el-form :model="form" label-position="right" class="demo-ruleForm">
                    <div data-v-da9757c6="" class="adgroup-item2">定向设置</div>
                    <el-form-item label="定向包名" prop="pkgname" label-width="152px">
                        <el-input v-model="form.pkgname" style="width: 400px;" maxlength="200" placeholder="请输入定向包名"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="地域" prop="name" label-width="152px">
                        <el-radio-group v-model="form.regionType">
                            <el-radio-button label="COMMON">不限</el-radio-button>
                            <el-radio-button label="CUSTOM">自定义</el-radio-button>
                        </el-radio-group>

                        <div v-if="form.regionType === 'CUSTOM'" class="region-custom-box">
                            <div class="checkIndex" v-loading="loading" element-loading-text="加载中"
                                element-loading-spinner="el-icon-loading">
                                <el-checkbox size="medium" v-model="diyuselectAll" :indeterminate="diyuisIndeterminate"
                                    @change="diyulevelTab($event)">快捷选择</el-checkbox>
                                <div class="checkView" v-for="(item, index) in areaList" :key="index">
                                    <!-- {{ item }} -->
                                    <el-checkbox size="medium" v-model="item.selectAll"
                                        :indeterminate="item.isIndeterminate"
                                        @change="levelTab($event, index)"></el-checkbox>
                                    <div @click="checkTab(index)" class="address" style="cursor: pointer;">
                                        {{ item.label }}
                                        <i class="el-icon-arrow-down"></i>
                                        <i style="color: #0080ff;">{{
                                            item.childvalue.length > 0 ? `(${item.childvalue.length})` : ''
                                        }}</i>
                                    </div>
                                    <div class="mobileCehck" v-if="item.show">
                                        <el-cascader-panel ref="region" v-model="item.childvalue" :options="testList"
                                            :props="props" collapse-tags :show-all-levels="false"
                                            @change="handleChange($event, index)" filterable>
                                        </el-cascader-panel>
                                    </div>
                                </div>
                            </div>







                        </div>
                    </el-form-item>
                    <el-form-item label="性别" prop="gender" label-width="152px">
                        <el-radio-group v-model="form.gender">
                            <el-radio-button label="COMMON">不限</el-radio-button>
                            <el-radio-button label="MALE">男</el-radio-button>
                            <el-radio-button label="FEMALE">女</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="年龄" prop="selectedAges" label-width="152px">

                        <el-checkbox-group v-model="form.selectedAges" @change="handleAgeChange">
                            <el-checkbox-button v-for="age in ageOptions" :key="age.value" :label="age.value">
                                {{ age.label }}
                            </el-checkbox-button>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="操作系统" prop="osType" label-width="152px">
                        <el-radio-group v-model="form.osType">
                            <el-radio-button label="COMMON">不限</el-radio-button>
                            <el-radio-button label="IOS">iOS</el-radio-button>
                            <el-radio-button label="ANDROID">安卓</el-radio-button>
                        </el-radio-group>


                    </el-form-item>
                    <el-form-item label="手机价格" prop="selectedPhonePrices" label-width="152px" v-if="form.osType != 'IOS'">
                        <el-checkbox-group v-model="form.selectedPhonePrices" @change="handlePriceChange">
                            <el-checkbox-button v-for="price in phonePriceOptions" :key="price.value" :label="price.value">
                                {{ price.label }}
                            </el-checkbox-button>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="网络情况" prop="selectedNetworks" label-width="152px">
                        <el-checkbox-group v-model="form.selectedNetworks" @change="handleNetworkChange">
                            <el-checkbox-button v-for="network in networkOptions" :key="network.value"
                                :label="network.value">
                                {{ network.label }}
                            </el-checkbox-button>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="投放时段" prop="timeSettings" label-width="152px">
                        <el-radio-group v-model="form.timeType" @change="handleTimeTypeChange">
                            <el-radio-button label="COMMON">不限</el-radio-button>
                            <el-radio-button label="CUSTOM">时段定向</el-radio-button>
                        </el-radio-group>

                        <div v-if="form.timeType === 'CUSTOM'" class="time-custom-box">
                            <div class="timeRange">
                                <div class="calendar">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th rowspan="6" class="weekRow"><b>周/时间</b></th>
                                                <th colspan="12"><b>00:00 - 12:00</b></th>
                                                <th colspan="12"><b>12:00 - 24:00</b></th>
                                            </tr>
                                            <tr>
                                                <td colspan="1" v-for="index in 24" :key="index">{{ index - 1 }}</td>
                                            </tr>
                                        </thead>
                                        <tbody @mousemove.prevent="handleMouseMove">
                                            <tr v-for="(item, index) in weekDate" :key="index">
                                                <td>{{ item }}</td>
                                                <td class="calendar-atom-time" v-for="i in 24" :key="index + '-' + i"
                                                    :class="{ 'active': selectCells[`${index}_${i}`] }"
                                                    @mousedown.prevent="handleMouseDown(index, i, $event)"
                                                    @mouseup.prevent="handleMouseUp(index, i)">
                                                </td>
                                            </tr>
                                            <div id="box" v-show="moveStartEvent"></div>
                                        </tbody>
                                    </table>
                                    <div class="table-core">
                                        <div class="clearfix">
                                            <span class="pull-left tip-text">可拖动鼠标选择时间段</span>

                                        </div>
                                        <el-button type="primary" @click="handleClear">清除所有</el-button>
                                        <ul>
                                            <li v-for="(item, index) in selectDate" :key="index"
                                                v-if="item.data && item.data.length">
                                                <label>{{ item.label }}</label>
                                                <span v-for="(o, idx) in item.data" :key="idx">{{ o[0] }}~{{ o[1] }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- <el-button type="primary" @click="getsumtime">计算开始</el-button> -->
                            </div>



                        </div>
                    </el-form-item>

                    <el-form-item label="安装包定向" prop="appPackage" label-width="152px">
                        <el-radio-group v-model="form.appPackage">
                            <el-radio-button label="DISABLE">关闭</el-radio-button>
                            <el-radio-button label="ENABLE">开启</el-radio-button>
                        </el-radio-group>

                        <div v-if="form.appPackage === 'ENABLE'" style="margin-top: 20px;">
                            <el-input v-model="form.appPackageValue" style="width: 400px;" maxlength="200"
                                placeholder="多个请用英文逗号分隔，最多10个，按回车键Enter保存"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="安装包排除" prop="appFilter" label-width="152px">
                        <el-radio-group v-model="form.appFilter">
                            <el-radio-button label="DISABLE">关闭</el-radio-button>
                            <el-radio-button label="ENABLE">开启</el-radio-button>
                        </el-radio-group>

                        <div v-if="form.appFilter === 'ENABLE'" style="margin-top: 20px;">
                            <el-input v-model="form.appFilterValue" style="width: 400px;" maxlength="200"
                                placeholder="多个请用英文逗号分隔，最多10个，按回车键Enter保存"></el-input>
                        </div>
                    </el-form-item>


                    <el-form-item label="是否开启过滤已转化用户" prop="conversion_filter_orient_status" label-width="172px">
                        <el-radio-group v-model="form.conversion_filter_orient_status">
                            <el-radio-button label="DISABLE">关闭</el-radio-button>
                            <el-radio-button label="ENABLE">开启</el-radio-button>
                        </el-radio-group>
                        <div class="form-tip">*付费方式为oCPX时该设置生效</div>

                    </el-form-item>
                    <el-form-item label="过滤已转化用户" prop="conversion_filter_orient" label-width="152px"
                        v-if="form.conversion_filter_orient_status == 'ENABLE'">
                        <el-radio-group v-model="form.conversion_filter_orient">
                            <el-radio-button v-for="item in conversion_filter_orientOption" :key="item.value"
                                :label="item.value">{{
                                    item.label }}</el-radio-button>
                        </el-radio-group>

                    </el-form-item>
                    <el-form-item label="" prop="pack_name_value" label-width="152px"
                        v-if="form.conversion_filter_orient == 'PACKAGE' && form.conversion_filter_orient_status == 'ENABLE'">

                        <div style="margin-top: 20px;">
                            <el-input v-model="form.pack_name_value" style="width: 400px;" maxlength="200"
                                placeholder="多个请用英文逗号分隔，最多10个，按回车键Enter保存"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="过滤时间" prop="conversion_filter_orient_duration" label-width="152px"
                        v-if="form.conversion_filter_orient_status == 'ENABLE' && (form.conversion_filter_orient == 'ACCOUNT' || form.conversion_filter_orient == 'COMPANY' || form.conversion_filter_orient == 'PRODUCT' || form.conversion_filter_orient == 'PACKAGE')">
                        <el-radio-group v-model="form.conversion_filter_orient_duration">
                            <el-radio-button v-for="item in conversion_filter_orient_durationoption" :key="item.value"
                                :label="item.value">{{
                                    item.label }}</el-radio-button>
                        </el-radio-group>

                    </el-form-item>
                    <el-form-item label="过滤转化目标" prop="conversion_goal_filter" label-width="152px"
                        v-if="form.conversion_filter_orient_status == 'ENABLE' && (form.conversion_filter_orient != 'COMMON')">
                        <el-select v-model="form.conversion_goal_filter" placeholder="请选择">
                            <el-option v-for="item in conversion_goal_filterOption" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>

                        </el-select>

                    </el-form-item>


                </el-form>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="postdingxiang">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="修改创意素材" :visible.sync="creativeMaterialsedit" width="1160px" append-to-body
            @close="closebiaodanedit">
            <div class="m-header" style="height: 550px;overflow-y: auto;">
                <el-form :model="form" label-position="right" class="demo-ruleForm">
                    <div data-v-da9757c6="" class="adgroup-item2">定向设置</div>
                    <el-form-item label="定向包名" prop="pkgname" label-width="152px">
                        <el-input v-model="editform.pkgname" style="width: 400px;" maxlength="200" placeholder="请输入定向包名"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="地域" prop="name" label-width="152px">
                        <el-radio-group v-model="editform.regionType">
                            <el-radio-button label="COMMON">不限</el-radio-button>
                            <el-radio-button label="CUSTOM">自定义</el-radio-button>
                        </el-radio-group>

                        <div v-if="editform.regionType === 'CUSTOM'" class="region-custom-box">
                            <div class="checkIndex" v-loading="loading" element-loading-text="加载中"
                                element-loading-spinner="el-icon-loading">
                                <el-checkbox size="medium" v-model="editform.diyuselectAll"
                                    :indeterminate="editform.diyuisIndeterminate"
                                    @change="diyulevelTab($event)">快捷选择</el-checkbox>
                                <div class="checkView" v-for="(item, index) in areaList" :key="index">
                                    <!-- {{ item }} -->
                                    <el-checkbox size="medium" v-model="item.selectAll"
                                        :indeterminate="item.isIndeterminate"
                                        @change="levelTab($event, index)"></el-checkbox>
                                    <div @click="checkTab(index)" class="address" style="cursor: pointer;">
                                        {{ item.label }}
                                        <i class="el-icon-arrow-down"></i>
                                        <i style="color: #0080ff;">{{
                                            item.childvalue.length > 0 ? `(${item.childvalue.length})` : ''
                                        }}</i>
                                    </div>
                                    <div class="mobileCehck" v-if="item.show">
                                        <el-cascader-panel ref="region" v-model="item.childvalue" :options="testList"
                                            :props="props" collapse-tags :show-all-levels="false"
                                            @change="handleChange($event, index)" filterable>
                                        </el-cascader-panel>
                                    </div>
                                </div>
                            </div>







                        </div>
                    </el-form-item>
                    <el-form-item label="性别" prop="gender" label-width="152px">
                        <el-radio-group v-model="editform.gender">
                            <el-radio-button label="COMMON">不限</el-radio-button>
                            <el-radio-button label="MALE">男</el-radio-button>
                            <el-radio-button label="FEMALE">女</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="年龄" prop="selectedAges" label-width="152px">

                        <el-checkbox-group v-model="editform.selectedAges" @change="edithandleAgeChange">
                            <el-checkbox-button v-for="age in ageOptions" :key="age.value" :label="age.value">
                                {{ age.label }}
                            </el-checkbox-button>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="操作系统" prop="osType" label-width="152px">
                        <el-radio-group v-model="editform.osType">
                            <el-radio-button label="COMMON">不限</el-radio-button>
                            <el-radio-button label="IOS">iOS</el-radio-button>
                            <el-radio-button label="ANDROID">安卓</el-radio-button>
                        </el-radio-group>


                    </el-form-item>
                    <el-form-item label="手机价格" prop="selectedPhonePrices" label-width="152px"
                        v-if="editform.osType != 'IOS'">
                        <el-checkbox-group v-model="editform.selectedPhonePrices" @change="edithandlePriceChange">
                            <el-checkbox-button v-for="price in phonePriceOptions" :key="price.value" :label="price.value">
                                {{ price.label }}
                            </el-checkbox-button>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="网络情况" prop="selectedNetworks" label-width="152px">
                        <el-checkbox-group v-model="editform.selectedNetworks" @change="edithandleNetworkChange">
                            <el-checkbox-button v-for="network in networkOptions" :key="network.value"
                                :label="network.value">
                                {{ network.label }}
                            </el-checkbox-button>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="投放时段" prop="timeSettings" label-width="152px">
                        <el-radio-group v-model="editform.timeType" @change="handleTimeTypeChange">
                            <el-radio-button label="COMMON">不限</el-radio-button>
                            <el-radio-button label="CUSTOM">时段定向</el-radio-button>
                        </el-radio-group>

                        <div v-if="editform.timeType === 'CUSTOM'" class="time-custom-box">
                            <div class="timeRange">
                                <div class="calendar">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th rowspan="6" class="weekRow"><b>周/时间</b></th>
                                                <th colspan="12"><b>00:00 - 12:00</b></th>
                                                <th colspan="12"><b>12:00 - 24:00</b></th>
                                            </tr>
                                            <tr>
                                                <td colspan="1" v-for="index in 24" :key="index">{{ index - 1 }}</td>
                                            </tr>
                                        </thead>
                                        <tbody @mousemove.prevent="handleMouseMove">
                                            <tr v-for="(item, index) in weekDate" :key="index">
                                                <td>{{ item }}</td>
                                                <td class="calendar-atom-time" v-for="i in 24" :key="index + '-' + i"
                                                    :class="{ 'active': selectCells[`${index}_${i}`] }"
                                                    @mousedown.prevent="handleMouseDown(index, i, $event)"
                                                    @mouseup.prevent="handleMouseUp(index, i)">
                                                </td>
                                            </tr>
                                            <div id="box" v-show="moveStartEvent"></div>
                                        </tbody>
                                    </table>
                                    <div class="table-core">
                                        <div class="clearfix">
                                            <span class="pull-left tip-text">可拖动鼠标选择时间段</span>

                                        </div>
                                        <el-button type="primary" @click="handleClear">清除所有</el-button>
                                        <ul>
                                            <li v-for="(item, index) in selectDate" :key="index"
                                                v-if="item.data && item.data.length">
                                                <label>{{ item.label }}</label>
                                                <span v-for="(o, idx) in item.data" :key="idx">{{ o[0] }}~{{ o[1] }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <el-button type="primary" @click="getsumtime">计算开始</el-button>
                            </div>



                        </div>
                    </el-form-item>

                    <el-form-item label="安装包定向" prop="appPackage" label-width="152px">
                        <el-radio-group v-model="editform.appPackage">
                            <el-radio-button label="DISABLE">关闭</el-radio-button>
                            <el-radio-button label="ENABLE">开启</el-radio-button>
                        </el-radio-group>

                        <div v-if="editform.appPackage === 'ENABLE'" style="margin-top: 20px;">
                            <el-input v-model="editform.appPackageValue" style="width: 400px;" maxlength="200"
                                placeholder="多个请用英文逗号分隔，最多10个，按回车键Enter保存"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="安装包排除" prop="appFilter" label-width="152px">
                        <el-radio-group v-model="editform.appFilter">
                            <el-radio-button label="DISABLE">关闭</el-radio-button>
                            <el-radio-button label="ENABLE">开启</el-radio-button>
                        </el-radio-group>

                        <div v-if="editform.appFilter === 'ENABLE'" style="margin-top: 20px;">
                            <el-input v-model="editform.appFilterValue" style="width: 400px;" maxlength="200"
                                placeholder="多个请用英文逗号分隔，最多10个，按回车键Enter保存"></el-input>
                        </div>
                    </el-form-item>



                    <el-form-item label="是否开启过滤已转化用户" prop="conversion_filter_orient_status" label-width="172px">
                        <el-radio-group v-model="editform.conversion_filter_orient_status">
                            <el-radio-button label="DISABLE">关闭</el-radio-button>
                            <el-radio-button label="ENABLE">开启</el-radio-button>
                        </el-radio-group>
                        <div class="form-tip">*付费方式为oCPX时该设置生效</div>

                    </el-form-item>
                    <el-form-item label="过滤已转化用户" prop="conversion_filter_orient" label-width="152px"
                        v-if="editform.conversion_filter_orient_status == 'ENABLE'">
                        <el-radio-group v-model="editform.conversion_filter_orient">
                            <el-radio-button v-for="item in conversion_filter_orientOption" :key="item.value"
                                :label="item.value">{{
                                    item.label }}</el-radio-button>
                        </el-radio-group>

                    </el-form-item>
                    <el-form-item label="" prop="pack_name_value" label-width="152px"
                        v-if="editform.conversion_filter_orient == 'PACKAGE' && editform.conversion_filter_orient_status == 'ENABLE'">

                        <div style="margin-top: 20px;">
                            <el-input v-model="editform.pack_name_value" style="width: 400px;" maxlength="200"
                                placeholder="多个请用英文逗号分隔，最多10个，按回车键Enter保存"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="过滤时间" prop="conversion_filter_orient_duration" label-width="152px"
                        v-if="editform.conversion_filter_orient_status == 'ENABLE' && (editform.conversion_filter_orient == 'ACCOUNT' || editform.conversion_filter_orient == 'COMPANY' || editform.conversion_filter_orient == 'PRODUCT' || editform.conversion_filter_orient == 'PACKAGE')">
                        <el-radio-group v-model="editform.conversion_filter_orient_duration">
                            <el-radio-button v-for="item in conversion_filter_orient_durationoption" :key="item.value"
                                :label="item.value">{{
                                    item.label }}</el-radio-button>
                        </el-radio-group>

                    </el-form-item>
                    <el-form-item label="过滤转化目标" prop="conversion_goal_filter" label-width="152px"
                        v-if="editform.conversion_filter_orient_status == 'ENABLE' && (editform.conversion_filter_orient != 'COMMON')">
                        <el-select v-model="editform.conversion_goal_filter" placeholder="请选择">
                            <el-option v-for="item in conversion_goal_filterOption" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>

                        </el-select>

                    </el-form-item>

                </el-form>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="closebiaodanedit">取 消</el-button>
                <el-button type="primary" @click="editdingxiang">确 定</el-button>
            </span>
        </el-dialog>

    </el-container>
</template>

<script>
import axios from "axios";
import address from "../../until/qttaddress";

let a = address.map(item => ({
    label: item.name,
    value: item.code,
    selectAll: false,
    isIndeterminate: false,
    show: false,
    childvalue: [],
    children: item.children
}))
// console.log("a", a);

export default {
    data() {
        return {
            userId: '',
            dingxiangbaoData: [],
            regionOptions: [],
            selectedRegions: [],
            checkShow: '',
            input: '',
            creativeMaterials: false,

            loading: false,
            areaList: a,
            testList: this.transformData(address),
            props: {
                value: 'code',
                label: 'name',
                children: 'children',
                multiple: true,
                emitPath: false
            },
            form: {

                pkgname: '',
                selectedAges: ["COMMON"],
                selectedNetworks: ["COMMON"],
                regionType: 'COMMON',
                selectedRegions: [],
                gender: 'COMMON',
                ageType: 'ALL',
                // selectedAges: ["COMMON"],
                phonePriceType: 'ALL',
                selectedPhonePrices: ["COMMON"],
                networkType: 'ALL',
                selectedNetworks: ["COMMON"],
                timeType: 'COMMON',
                osType: "COMMON",
                appPackage: 'DISABLE',
                appPackageValue: '',
                appFilter: 'DISABLE',
                appFilterValue: "",

                conversion_filter_orient_status: "DISABLE",
                conversion_filter_orient: 'COMMON',
                conversion_filter_orient_duration: "TODAY",
                pack_name_value: '',
                conversion_goal_filter: "ACTIVATION"
            },
            conversion_filter_orientOption: [

                { value: 'COMMON', label: '不限' },
                { value: 'CAMPAIGN', label: '计划' },
                { value: 'ADGROUP', label: '单元' },
                { value: 'ACCOUNT', label: '本账户' },
                { value: 'COMPANY', label: '公司主体' },
                { value: 'PRODUCT', label: '本产品' },
                { value: 'PACKAGE', label: '包名' },


            ],
            conversion_filter_orient_durationoption: [

                { value: 'TODAY', label: '当天' },
                { value: '7DAY', label: '7日' },
                { value: '14DAY', label: '14天' },
                { value: 'MONTH', label: '一个月' },
                { value: 'QUARTER', label: '三个月' },
                { value: 'HALF_YEAR', label: '六个月' },
                { value: 'YEAR', label: '一年' },
            ],
            conversion_goal_filterOption: [

                { value: 'ACTIVATION', label: '激活' },
                { value: 'CHARGE', label: '付费' },
                { value: 'FIRST_ACTIVATION', label: '首次拉活' },
                { value: 'EFFECTIVE_READING', label: '有效阅读' },
                { value: 'API_APP_KEYACTION', label: '关键行为' },
                { value: 'DEEP_REGISTER', label: '深度转化-注册' },
                { value: 'DEEP_RETENTION', label: '深度转化-次日留存' },
                { value: 'DEEP_CHARGE', label: '深度转化-付费' },
                { value: 'DEEP_CONSULT', label: '深度转化-有效咨询' },
                { value: 'DEEP_SIGN', label: '深度转化-签收' },
                { value: 'DEEP_COPIED_APPLY', label: '深度转化-复制报名' },
                { value: 'DEEP_INSTALL_ACHIEVEMENT', label: '深度转化-安装达成' },
                { value: 'DEEP_MINI_PROGRAM_CONSULT', label: '深度转化-有效咨询（小程序）' },
                { value: 'DEEP_FORM_CHARGE', label: '深度转化-表单付费' },
                { value: 'DEEP_API_PAY_IN_WECHAT', label: '深度转化-公众号内付费' },
                { value: 'DEEP_KEY_ACTION', label: '深度转化-关键行为' },
                { value: 'DEEP_RED_ENVELOPE', label: '深度转化-领取红包' },


            ],
            ageOptions: [
                { value: 'COMMON', label: '不限' },
                { value: 'AGE_STATE_ONE', label: '18岁以下' },
                { value: 'AGE_STATE_TWO', label: '18-24岁' },
                { value: 'AGE_STATE_THREE', label: '25-30岁' },
                { value: 'AGE_STATE_FOUR', label: '31-40岁' },
                { value: 'AGE_STATE_FIVE', label: '41-50岁' },
                { value: 'AGE_STATE_SIX', label: '51-60岁' },
                { value: 'AGE_STATE_SEVEN', label: '61岁以上' }
            ],
            selectedPhonePrices: ["COMMON"],
            phonePriceOptions: [
                { value: 'COMMON', label: '不限' },
                { value: 'HIGH', label: '高端' },
                { value: 'MIDDLE', label: '中高端' },
                { value: 'MIDDLE_AND_LOW', label: '中低端' },
                { value: 'LOW', label: '低端' }
            ],
            networkOptions: [
                { value: 'COMMON', label: '不限' },
                { value: 'WIFI', label: 'WIFI' },
                { value: '2G', label: '2G' },
                { value: '3G', label: '3G' },
                { value: '4G', label: '4G' },
                { value: '5G', label: '5G' }
            ],
            regionOptions: [
                { value: 'SHANGHAI', label: '上海' },
                { value: 'BEIJING', label: '北京' },
                { value: 'GUANGDONG', label: '广东' },
                { value: 'ZHEJIANG', label: '浙江' }
            ],
            // areaList: [],
            // testList: [],
            cascaderProps: {
                checkStrictly: false, // 手动控制父子关联
                multiple: true,
                emitPath: false,
                label: 'name',
                value: 'code',
                children: 'children'
            },
            previousSelectedCodes: [],
            diyuselectAll: false,
            diyuisIndeterminate: false,


            weekDate: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
            selectCells: {},
            selectDate: {},
            moveStartEvent: false,
            moveStartColumn: 0,
            moveStarRow: 0,
            moveStartX: 0,
            moveStartY: 0,

            //修改
            creativeMaterialsedit: false,
            editform: {
                id: '',
                pkgname: '',
                diyuselectAll: false,
                diyuisIndeterminate: false,
                gender: '',
                selectedAges: ['COMMON'],
                osType: '',
                selectedPhonePrices: [],
                selectedNetworks: [],
                timeType: 'COMMON',
                appPackage: '',
                appPackageValue: '',
                appFilter: '',
                appFilterValue: '',
                regionType: 'COMMON',
                conversion_filter_orient_status: "DISABLE",
                conversion_filter_orient: 'COMMON',
                conversion_filter_orient_duration: "TODAY",
                pack_name_value: '',
                conversion_goal_filter: "ACTIVATION"

            }
        };
    },
    created() {
        this.userId = this.$route.query.userId

        if (!this.userId) {
            // 使用Element UI的消息提示
            this.$message.warning('您得先登录')

            // 设置延迟跳转让用户看到提示
            setTimeout(() => {
                // 重定向到登录页面（外部链接）
                window.location.href = 'https://control.zjwec.cn/page/end/login.html'
            }, 1500)  // 1.5秒后跳转
            return
            // 终止后续执行
        }
        // this.addresstable()
        this.getdingixnagbaolist()
    },
    watch: {

    },
    methods: {
        async selectdxb() {
            console.log(this.input);
            // if (!this.input || this.input.trim() === '') {
            //     this.$message.warning('请输入有效的包名');
            //     return;
            // }
            try {
                // 调用删除接口
                const res = await axios.get('https://control.zjwec.cn/rgionPgk/getByPkgName', {
                    params: { keyword: this.input,userid:this.userId } // 替换为你的参数
                }).then(res => {
                    this.dingxiangbaoData = res.data
                    this.$message.success('查询成功');
                });

            } catch (error) {
                console.error('查询失败:', error);
                this.$message.error('查询失败: ');
            }
        },
        editdxbao(params) {
            this.creativeMaterialsedit = true
            console.log(params);
            let str = JSON.parse(params.pkgjson)
            console.log(str);
            this.editform = { ...this.editform, pkgname: params.pkgname, id: params.id }

            if (str.app_filter_value_arr) {
                if (str.app_filter_value_arr.length > 0) {
                    let inputstr = '';
                    for (let i = 0; i < str.app_filter_value_arr.length; i++) {

                        inputstr += str.app_filter_value_arr[i];
                        if (i >= 0) {
                            inputstr += ';'; // 不是第一个元素就添加分号
                        }
                    }
                    this.editform = {
                        ...this.editform, appFilterValue: inputstr,
                        appFilter: 'ENABLE'
                    }
                    // this.editform = {
                    //     ...this.editform, appFilterValue: str.app_filter_value_arr,
                    //     appFilter: 'ENABLE'
                    // }
                } else {
                    this.editform = { ...this.editform, appFilter: 'DISABLE' }
                }

            }
            if (str.app_package_value_arr) {
                if (str.app_package_value_arr.length > 0) {
                    let inputstr = '';
                    for (let i = 0; i < str.app_package_value_arr.length; i++) {

                        inputstr += str.app_package_value_arr[i];
                        if (i >= 0) {
                            inputstr += ';'; // 不是第一个元素就添加分号
                        }
                    }
                    this.editform = {
                        ...this.editform, appPackageValue: inputstr,
                        appPackage: 'ENABLE'
                    }
                } else {
                    this.editform = { ...this.editform, appPackage: 'DISABLE' }
                }
                // this.editform={...this.editform,appPackageValue:str.app_package_value_arr}
            }
            if (str.gender) {
                this.editform = { ...this.editform, gender: str.gender }
            }
            if (str.osType) {
                this.editform = { ...this.editform, osType: str.osType }
            }
            if (str.selectedAges) {
                this.editform = { ...this.editform, selectedAges: str.selectedAges }
            }
            if (str.selectedPhonePrices) {
                this.editform = { ...this.editform, selectedPhonePrices: str.selectedPhonePrices }
            }
            if (str.selectedNetworks) {
                this.editform = { ...this.editform, selectedNetworks: str.selectedNetworks }
            }
            if (str.selectedPhonePrices) {
                this.editform = { ...this.editform, selectedPhonePrices: str.selectedPhonePrices }
            }

            if (str.timeType) {
                // console.log("222");
                this.editform = { ...this.editform, timeType: 'CUSTOM' }

                let arr = str.timeType
                console.log(arr);
                let a = this.decodeHoursToSelectCells(arr)
                console.log(a);
                this.selectCells = a

                let b = this.convertToTimeRanges(arr)
                console.log(b);
                this.selectDate = b
            }

            if (str.regionType) {
                this.editform.regionType = 'CUSTOM'
                let c = this.decodeSelectedAreas(str.regionType, this.areaList)
                this.areaList = c
                console.log(c);
            }

            this.editform = { ...this.editform, conversion_filter_orient_status: str.conversion_filter_orient_status }
            if (str.conversion_filter_orient_status == 'ENABLE') {

                if (str.conversion_filter_orient == "COMMON") {
                    // this.editform={...this.editform,conversion_filter_orient:str.conversion_filter_orient}
                } else {
                    let form
                    if (str.conversion_filter_orient == 'ACCOUNT' || str.conversion_filter_orient == 'COMPANY' || str.conversion_filter_orient == 'PRODUCT' || str.form.conversion_filter_orient == 'PACKAGE') {

                        form = {
                            conversion_filter_orient: str.conversion_filter_orient,
                            conversion_filter_orient_duration: str.conversion_filter_orient_duration,
                            conversion_goal_filter: str.conversion_goal_filter
                        }
                        if (str.conversion_filter_orient == 'PACKAGE') {
                            // let arr = this.form.pack_name_value.split(";");
                            form = { ...form, pack_name_value: str.pack_name_value }
                        }
                        this.editform = { ...this.editform, ...form }
                    } else {
                        form = {
                            conversion_filter_orient: str.conversion_filter_orient,
                            conversion_goal_filter: str.form.conversion_goal_filter
                        }
                        this.editform = { ...this.editform, ...form }
                    }

                }
            }



        },
        async deletedxb(row) {
            console.log(row.id);
            try {
                // 调用删除接口
                const res = await axios.get('https://control.zjwec.cn/rgionPgk/delete', {
                    params: { id: row.id,userid:this.userId } // 替换为你的参数
                });

                this.$message.success('删除成功');
                this.getdingixnagbaolist()
                // this.$emit('deleted'); // 触发事件通知父组件
            } catch (error) {
                console.error('删除失败:', error);
                this.$message.error('删除失败: ');
                this.getdingixnagbaolist()
            }
        },
        getdingixnagbaolist() {
            axios.get('https://control.zjwec.cn/rgionPgk/list',{
                    params: { userid:this.userId } // 替换为你的参数
                }).then(res => {
                console.log(res);
                this.dingxiangbaoData = res.data.data
            })
        },
        closebiaodan() {
            this.form = {
                pkgname: '',
                selectedAges: ["COMMON"],
                selectedNetworks: ["COMMON"],
                regionType: 'COMMON',
                selectedRegions: [],
                gender: 'COMMON',
                ageType: 'ALL',
                // selectedAges: ["AGE_STATE_ALL"],
                phonePriceType: 'ALL',
                selectedPhonePrices: ["COMMON"],
                networkType: 'ALL',
                selectedNetworks: ["COMMON"],
                timeType: 'COMMON',
                osType: "COMMON",
                appPackage: 'DISABLE',
                appPackageValue: '',
                appFilter: 'DISABLE',
                conversion_filter_orient_status: "DISABLE",
                conversion_filter_orient: 'COMMON',
                conversion_filter_orient_duration: "TODAY",
                appFilterValue: ""
            }
            this.areaList = address.map(item => ({
                label: item.name,
                value: item.code,
                selectAll: false,
                isIndeterminate: false,
                show: false,
                childvalue: [],
                children: item.children
            }))
            this.weekDate = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
                this.selectCells = {},
                this.selectDate = {},
                this.moveStartEvent = false,
                this.moveStartColumn = 0,
                this.moveStarRow = 0,
                this.moveStartX = 0,
                this.moveStartY = 0,
                this.creativeMaterials = false
        },
        closebiaodanedit() {
            this.editform = {
                id: '',
                pkgname: '',
                diyuselectAll: false,
                diyuisIndeterminate: false,
                gender: '',
                selectedAges: ['COMMON'],
                osType: '',
                selectedPhonePrices: [],
                selectedNetworks: [],
                timeType: 'COMMON',
                appPackage: '',
                appPackageValue: '',
                appFilter: '',
                appFilterValue: '',
                regionType: 'COMMON'
            }
            console.log(a);
            this.areaList = address.map(item => ({
                label: item.name,
                value: item.code,
                selectAll: false,
                isIndeterminate: false,
                show: false,
                childvalue: [],
                children: item.children
            }))
            this.weekDate = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
                this.selectCells = {},
                this.selectDate = {},
                this.moveStartEvent = false,
                this.moveStartColumn = 0,
                this.moveStarRow = 0,
                this.moveStartX = 0,
                this.moveStartY = 0,
                this.creativeMaterialsedit = false
        },
        postdingxiang() {
            //地址
            let arr = []
            console.log(this.areaList);
            let address = this.areaList.map(item => {
                if (item.selectAll || item.childvalue.length > 0) {
                    if (item.children.length > 0) {
                        if (item.children.length == item.childvalue.length) {
                            arr = [...arr, item.value]
                        } else {

                            arr = [...arr, ...item.childvalue]
                        }
                    } else {
                        arr = [...arr, item.value]
                    }

                }
            })
            console.log(arr);
            //性别
            let sex = this.form.gender
            //年龄
            let age = this.form.selectedAges
            //操作系统
            let osType = this.form.osType
            //手机价格
            let selectedPhonePrices = this.form.selectedPhonePrices
            //网络情况
            let selectedNetworks = this.form.selectedNetworks
            //安装包
            let app_package_value_arr = this.form.appPackageValue.split(';').filter(line => line.trim());
            let app_filter_value_arr = this.form.appFilterValue.split(';').filter(line => line.trim());

            let form
            if (this.form.regionType == 'COMMON') {
                form = {
                    gender: this.form.gender,
                    selectedAges: age,
                    osType,
                    selectedPhonePrices,
                    selectedNetworks,
                    app_package_value_arr,
                    app_filter_value_arr
                }
                if (this.form.timeType == 'CUSTOM') {
                    form = {
                        gender: this.form.gender,
                        selectedAges: age,
                        osType,
                        selectedPhonePrices,
                        selectedNetworks,
                        app_package_value_arr,
                        app_filter_value_arr,
                        timeType: this.getsumtime()
                    }
                }
            } else {
                form = {
                    regionType: arr,
                    gender: this.form.gender,
                    selectedAges: age,
                    osType,
                    selectedPhonePrices,
                    selectedNetworks,
                    app_package_value_arr,
                    app_filter_value_arr,
                    regionType: arr
                }
                if (this.form.timeType == 'CUSTOM') {
                    form = {
                        gender: this.form.gender,
                        selectedAges: age,
                        osType,
                        selectedPhonePrices,
                        selectedNetworks,
                        app_package_value_arr,
                        app_filter_value_arr,
                        regionType: arr,
                        timeType: this.getsumtime()
                    }
                }
            }

            if (this.form.conversion_filter_orient_status == 'ENABLE') {
                if (this.form.conversion_filter_orient == "COMMON") {
                    // form = { ...form, conversion_filter_orient: this.form.conversion_filter_orient }
                } else {
                    if (this.form.conversion_filter_orient == 'ACCOUNT' || this.form.conversion_filter_orient == 'COMPANY' || this.form.conversion_filter_orient == 'PRODUCT' || this.form.conversion_filter_orient == 'PACKAGE') {
                        form = {
                            ...form,
                            conversion_filter_orient: this.form.conversion_filter_orient,
                            conversion_filter_orient_duration: this.form.conversion_filter_orient_duration,
                            conversion_goal_filter: this.form.conversion_goal_filter
                        }
                        if (this.form.conversion_filter_orient == 'PACKAGE') {
                            // let arr = this.form.pack_name_value.split(";");
                            form = { ...form, pack_name_value: this.form.pack_name_value }
                        }
                    } else {
                        form = {
                            ...form,
                            conversion_filter_orient: this.form.conversion_filter_orient,
                            conversion_goal_filter: this.form.conversion_goal_filter
                        }
                    }

                }
            } else {
                form = { ...form, conversion_filter_orient_status: "DISABLE", }
            }


            console.log(form);
            console.log(JSON.stringify(form));
            axios.post('https://control.zjwec.cn/rgionPgk/create', {
                pkgname: this.form.pkgname,
                pkgjson: JSON.stringify(form),
                userid:this.userId
            }).then(res => {
                console.log(res);
                this.$message.success('上传成功')
                this.form = {
                    pkgname: '',
                    selectedAges: ["COMMON"],
                    selectedNetworks: ["COMMON"],
                    regionType: 'COMMON',
                    selectedRegions: [],
                    gender: 'COMMON',
                    ageType: 'ALL',
                    phonePriceType: 'ALL',
                    selectedPhonePrices: ["COMMON"],
                    networkType: 'ALL',
                    selectedNetworks: ["COMMON"],
                    timeType: 'COMMON',
                    osType: "COMMON",
                    appPackage: 'DISABLE',
                    appPackageValue: '',
                    appFilter: 'DISABLE',
                    appFilterValue: ""
                }
                this.getdingixnagbaolist()
                this.creativeMaterials = false

            })
        },
        editdingxiang() {
            let arr = []
            console.log(this.areaList);
            let address = this.areaList.map(item => {
                if (item.selectAll || item.childvalue.length > 0) {
                    if (item.children.length > 0) {
                        if (item.children.length == item.childvalue.length) {
                            arr = [...arr, item.value]
                        } else {

                            arr = [...arr, ...item.childvalue]
                        }
                    } else {
                        arr = [...arr, item.value]
                    }

                }
            })
            console.log(arr);
            //性别1
            let sex = this.editform.gender
            //年龄
            let age = this.editform.selectedAges
            //操作系统
            let osType = this.editform.osType
            //手机价格
            let selectedPhonePrices = this.editform.selectedPhonePrices
            //网络情况
            let selectedNetworks = this.editform.selectedNetworks
            //安装包
            let app_package_value_arr = this.editform.appPackageValue.split(';').filter(line => line.trim());
            let app_filter_value_arr = this.editform.appFilterValue.split(';').filter(line => line.trim());

            let form
            if (this.editform.regionType == 'COMMON') {
                form = {
                    gender: sex,
                    selectedAges: age,
                    osType,
                    selectedPhonePrices,
                    selectedNetworks,
                    app_package_value_arr,
                    app_filter_value_arr
                }
                if (this.editform.timeType == 'CUSTOM') {
                    form = {
                        gender: sex,
                        selectedAges: age,
                        osType,
                        selectedPhonePrices,
                        selectedNetworks,
                        app_package_value_arr,
                        app_filter_value_arr,
                        timeType: this.getsumtime()
                    }
                }
            } else {
                form = {
                    regionType: arr,
                    gender: sex,
                    selectedAges: age,
                    osType,
                    selectedPhonePrices,
                    selectedNetworks,
                    app_package_value_arr,
                    app_filter_value_arr,
                    regionType: arr
                }
                if (this.editform.timeType == 'CUSTOM') {
                    form = {
                        gender: sex,
                        selectedAges: age,
                        osType,
                        selectedPhonePrices,
                        selectedNetworks,
                        app_package_value_arr,
                        app_filter_value_arr,
                        regionType: arr,
                        timeType: this.getsumtime()
                    }
                }
            }


            console.log(this.editform.conversion_filter_orient_status);
            if (this.editform.conversion_filter_orient_status == 'ENABLE') {
                form = { ...form, conversion_filter_orient_status: "ENABLE", }
                if (this.editform.conversion_filter_orient == "COMMON") {
                    // form = { ...form, conversion_filter_orient: this.editform.conversion_filter_orient }
                } else {
                    if (this.editform.conversion_filter_orient == 'ACCOUNT' || this.editform.conversion_filter_orient == 'COMPANY' || this.editform.conversion_filter_orient == 'PRODUCT' || this.editform.conversion_filter_orient == 'PACKAGE') {
                        form = {
                            ...form,
                            conversion_filter_orient: this.editform.conversion_filter_orient,
                            conversion_filter_orient_duration: this.editform.conversion_filter_orient_duration,
                            conversion_goal_filter: this.editform.conversion_goal_filter
                        }
                        if (this.editform.conversion_filter_orient == 'PACKAGE') {
                            let arr = this.editform.pack_name_value.split(";");
                            form = { ...form, pack_name_value: arr }
                        }
                    } else {
                        form = {
                            ...form,
                            conversion_filter_orient: this.editform.conversion_filter_orient,
                            conversion_goal_filter: this.editform.conversion_goal_filter
                        }
                    }

                }
            } else {
                form = { ...form, conversion_filter_orient_status: "DISABLE", }
            }


            console.log(form);
            console.log(JSON.stringify(form));
            axios.put('https://control.zjwec.cn/rgionPgk/update', {
                id: this.editform.id,
                pkgname: this.editform.pkgname,
                pkgjson: JSON.stringify(form),
                userid:this.userId
            }).then(res => {
                console.log(res);
                this.$message.success('上传成功')
                this.closebiaodanedit()
                this.getdingixnagbaolist()
                this.creativeMaterialsedit = false

            })
        },
        diyulevelTab(event) {
            console.log(event);
            const area = this.areaList
            if (event) {
                for (let index = 0; index < area.length; index++) {
                    const area2 = area[index]
                    this.testList = area[index].children;
                    area2.childvalue = this.testList.map(city => [city.code])
                    area2.selectAll = true
                }

            } else {
                // this.areaList[index].isIndeterminate = false
                area.childvalue = []
                for (let index = 0; index < area.length; index++) {
                    const area2 = area[index]
                    this.testList = area[index].children;
                    area2.childvalue = []
                    area2.selectAll = false
                }
            }
            console.log(this.areaList);
        },
        transformData(data) {
            // console.log("b", data);
            if (!data || !Array.isArray(data)) return []
            return data.map(item => ({
                code: item.code,
                name: item.name,
                children: item.children && item.children.length > 0
                    ? this.transformData(item.children)
                    : undefined
            }))
        },
        checkTab(index) {
            // this.checkShow = index + 1

            // / 先收起所有已展开的省份
            this.areaList.forEach((item, i) => {
                item.show = i === index ? !item.show : false;
            });

            // 设置当前省份的城市数据
            if (this.areaList[index].show) {
                this.testList = this.areaList[index].children || [];
            }
        },
        levelTab(checked, index) {
            console.log(checked);
            console.log(index);
            this.testList = this.areaList[index].children
            const area = this.areaList[index]
            console.log(area);
            if (checked) {
                area.childvalue = this.testList.map(city => city.code)

            } else {
                this.areaList[index].isIndeterminate = false
                area.childvalue = []

            }
            area.isIndeterminate = false
        },
        handleChange(value, index) {
            console.log(value);
            const area = this.areaList[index]
            area.selectAll = value.length > 0 && value.length === this.testList.length
            area.isIndeterminate = value.length > 0 && !area.selectAll
        },
        getCityCount(provinceName) {
            const province = this.testList.find(p => p.name === provinceName)
            return province && province.children ? province.children.length : 0
        },
        clearAllRegions() {
            this.selectedRegions = []; // 清空已选地区数组
        },
        selectAll() {
            // 获取所有叶子节点的值
            const getAllLeafNodes = (nodes) => {
                let result = [];
                nodes.forEach(node => {
                    if (node.children && node.children.length > 0) {
                        result = result.concat(getAllLeafNodes(node.children));
                    } else {
                        result.push(node.value);
                    }
                });
                return result;
            };

            this.selectedRegions = getAllLeafNodes(this.regionOptions);
        },
        clearjl() {
            this.$refs.address.clearCheckedNodes();
        },
        // 处理地区选择变化
        handleRegionChange(value) {
            console.log('当前选择:', value);

            // 1. 找出新选择的节点（对比前后差异）
            const newlySelected = value.filter(code =>
                !this.previousSelectedCodes.includes(code)
            );

            // 2. 如果新选择的是父级节点，自动添加所有子级
            newlySelected.forEach(code => {
                const node = this.findNodeByCode(this.regionOptions, code);
                if (node.children) {
                    const childCodes = this.getAllChildCodes(node);
                    value = [...new Set([...value, ...childCodes])];
                }
            });

            // 3. 更新选中值
            this.selectedRegions = value;
            this.previousSelectedCodes = [...value]; // 保存当前选中状态
        },

        // 辅助方法：根据 code 查找节点
        findNodeByCode(nodes, code) {
            for (const node of nodes) {
                if (node.code === code) return node;
                if (node.children) {
                    const found = this.findNodeByCode(node.children, code);
                    if (found) return found;
                }
            }
            return null;
        },

        // 辅助方法：获取所有子节点的 code
        getAllChildCodes(node) {
            if (!node.children) return [node.code];
            return node.children.flatMap(child => this.getAllChildCodes(child));
        },

        // 删除已选地区
        removeRegion(index) {
            this.selectedRegions.splice(index, 1);
        },
        // 根据code数组获取地区路径
        getRegionPathByCodes(codes) {
            const result = [];
            let currentNodes = this.regionOptions;

            codes.forEach(code => {
                const findNode = (nodes) => {
                    for (const node of nodes) {
                        if (node.code === code) {
                            result.push(node.name);
                            return node.children || [];
                        }
                        if (node.children) {
                            const found = findNode(node.children);
                            if (found.length) return found;
                        }
                    }
                    return [];
                };
                currentNodes = findNode(currentNodes);
            });

            return result;
        },
        handleSelect(item) {
            // 处理地区选择
            if (!this.form.selectedRegions.includes(item.value)) {
                this.form.selectedRegions.push(item.value);
            }
        },
        querySearchAsync(queryString, cb) {
            // 这里实现地区搜索逻辑
            const results = this.regionOptions.filter(region =>
                region.label.includes(queryString)
            );
            cb(results);
        },

        handleTimeTypeChange(val) {
            // if (val === 'COMMON') {
            //     this.resetSelection()
            // }
        },
        handleNetworkChange(selectedValues) {
            const allValue = 'COMMON';
            const allIndex = selectedValues.indexOf(allValue);

            if (selectedValues.includes(allValue) && (allIndex == selectedValues.length - 1)) {
                // console.log(1);
                this.form.selectedNetworks = [allValue];
            } else if (selectedValues.length > 0 && (allIndex != selectedValues.length - 1)) {
                // console.log(2);
                this.form.selectedNetworks = selectedValues.filter(v => v !== allValue);
            }
        },
        edithandleNetworkChange(selectedValues) {
            const allValue = 'COMMON';
            const allIndex = selectedValues.indexOf(allValue);

            if (selectedValues.includes(allValue) && (allIndex == selectedValues.length - 1)) {
                // console.log(1);
                this.editform.selectedNetworks = [allValue];
            } else if (selectedValues.length > 0 && (allIndex != selectedValues.length - 1)) {
                // console.log(2);
                this.editform.selectedNetworks = selectedValues.filter(v => v !== allValue);
            }
        },
        handleAgeChange(selectedValues) {
            const allValue = 'AGE_STATE_ALL';
            const allIndex = selectedValues.indexOf(allValue);

            if (selectedValues.includes(allValue) && (allIndex == selectedValues.length - 1)) {
                this.form.selectedAges = [allValue];
            } else if (selectedValues.length > 0 && (allIndex != selectedValues.length - 1)) {
                this.form.selectedAges = selectedValues.filter(v => v !== allValue);
            }
        },
        edithandleAgeChange(selectedValues) {
            const allValue = 'COMMON';
            const allIndex = selectedValues.indexOf(allValue);

            if (selectedValues.includes(allValue) && (allIndex == selectedValues.length - 1)) {
                this.editform.selectedAges = [allValue];
            } else if (selectedValues.length > 0 && (allIndex != selectedValues.length - 1)) {
                this.editform.selectedAges = selectedValues.filter(v => v !== allValue);
            }
        },
        addresstable() {

            for (let i = 0; i < address.length; i++) {
                address[i].show = false
                address[i].selectAll = false
                address[i].isIndeterminate = false
                address[i].value = []
                address[i].length = 0
                for (let j = 0; j < address[i].children.length; j++) {
                    address[i].length +=
                        address[i].children[j].length
                }
            }
            this.areaList = address
            this.regionOptions = address
            console.log(this.areaList);
        },
        opendialog() {
            this.creativeMaterials = true
        },
        handlePriceChange(selectedValues) {
            // console.log(selectedValues);
            const allValue = 'COMMON';
            const allIndex = selectedValues.indexOf(allValue);

            if (selectedValues.includes(allValue) && (allIndex == selectedValues.length - 1)) {
                // console.log(1);
                this.form.selectedPhonePrices = [allValue];
            } else if (selectedValues.length > 0 && (allIndex != selectedValues.length - 1)) {
                // console.log(2);
                this.form.selectedPhonePrices = selectedValues.filter(v => v !== allValue);
            }
        },
        edithandlePriceChange(selectedValues) {
            // console.log(selectedValues);
            const allValue = 'COMMON';
            const allIndex = selectedValues.indexOf(allValue);

            if (selectedValues.includes(allValue) && (allIndex == selectedValues.length - 1)) {
                // console.log(1);
                this.editform.selectedPhonePrices = [allValue];
            } else if (selectedValues.length > 0 && (allIndex != selectedValues.length - 1)) {
                // console.log(2);
                this.editform.selectedPhonePrices = selectedValues.filter(v => v !== allValue);
            }
        },


        getHoursArray() {
            return this.weekDate.map((_, dayIndex) => {
                let dayValue = 0;

                // 检查24个小时中哪些被选中了
                for (let hour = 1; hour <= 24; hour++) {
                    if (this.selectCells[`${dayIndex}_${hour}`]) {
                        // 注意：代码中hour是1-24，对应bit位的0-23位
                        dayValue += Math.pow(2, hour - 1);
                    }
                }

                return dayValue;
            });
        },
        decodeHoursToSelectCells(hoursArray, days = 7, hoursPerDay = 24) {
            const selectCells = {};
            hoursArray.slice(0, days).forEach((dayValue, dayIndex) => {
                if (dayValue <= 0) return; // 0表示未选择任何时段
                for (let hour = 1; hour <= hoursPerDay; hour++) {
                    if ((dayValue & (1 << (hour - 1)))) {
                        selectCells[`${dayIndex}_${hour}`] = true;
                    }
                }
            });
            return selectCells;
        },
        convertToTimeRanges(hoursArray) {
            const weekDays = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];

            return hoursArray.map((value, dayIndex) => {
                // 1. 解码选中时段（31的二进制是11111，即位0-4）
                const selectedHours = [];
                for (let i = 0; i < 24; i++) {
                    if (value & (1 << i)) {
                        selectedHours.push(i);
                    }
                }

                // 2. 合并连续时段
                const timeRanges = [];
                if (selectedHours.length > 0) {
                    let start = selectedHours[0];
                    let end = start;

                    for (let i = 1; i <= selectedHours.length; i++) {
                        if (i < selectedHours.length && selectedHours[i] === selectedHours[i - 1] + 1) {
                            end = selectedHours[i];
                        } else {
                            timeRanges.push([
                                `${start.toString().padStart(2, '0')}:00`,
                                `${(end + 1).toString().padStart(2, '0')}:00`
                            ]);
                            if (i < selectedHours.length) {
                                start = selectedHours[i];
                                end = start;
                            }
                        }
                    }
                }

                return {
                    label: weekDays[dayIndex],
                    data: timeRanges
                };
            });
        },
        decodeSelectedAreas(encodedValues, areaList) {
            // 1. 创建映射表：value -> areaItem
            const valueMap = {};
            areaList.forEach(item => {
                valueMap[item.value] = item;
                if (item.children) {
                    item.children.forEach(child => {
                        valueMap[child.value] = child;
                    });
                }
            });

            // 2. 重置所有选择状态
            areaList.forEach(item => {
                item.selectAll = false;
                item.childvalue = [];
                if (item.children) {
                    item.children.forEach(child => {
                        child.selected = false;
                    });
                }
            });

            // 3. 根据编码值恢复选择状态
            encodedValues.forEach(value => {
                const item = valueMap[value];
                if (!item) return;

                // 如果是省份value
                if (areaList.some(province => province.value === value)) {
                    const province = areaList.find(p => p.value === value);
                    province.selectAll = true;
                    if (province.children) {
                        province.childvalue = province.children.map(c => c.value);
                    }
                }
                // 如果是城市value
                else {
                    const province = areaList.find(p =>
                        p.children && p.children.some(c => c.value === value)
                    );
                    if (province) {
                        province.childvalue.push(value);
                        province.selectAll = province.childvalue.length === province.children.length;
                    }
                }
            });

            return areaList;
        },




        // 修改getData方法，返回hours数组格式
        getDatas() {
            return {
                hours: this.getHoursArray(),
                // 保留原始格式数据（如果需要）
                rawData: this.selectDate
            };
        },
        getsumtime() {

            const timeData = this.getDatas();
            console.log(timeData.hours);

            return timeData.hours
        },
        clone(obj) {
            return JSON.parse(JSON.stringify(obj));
        },

        init(data) {
            this.selectCells = data && data instanceof Object ? data : {};
            this.getSelectDate();
        },

        handleMouseDown(column, row, e) {
            console.log(this.selectDate);
            console.log(this.selectCells);
            this.moveStartEvent = true;
            this.moveStartColumn = column;
            this.moveStarRow = row;
            this.moveStartX = e.layerX;
            this.moveStartY = e.layerY;
        },

        handleMouseUp(column, row) {
            if (this.moveStartEvent) {
                this.moveStartEvent = false;
                const checked = !this.selectCells[`${column}_${row}`];

                if (row - this.moveStarRow > -1 && column - this.moveStartColumn > -1) {
                    const newSelectCells = { ...this.selectCells };

                    for (let i = this.moveStartColumn; i <= column; i++) {
                        for (let j = this.moveStarRow; j <= row && j <= 24; j++) {
                            const key = `${i}_${j}`;
                            if (checked) {
                                newSelectCells[key] = true;
                            } else {
                                delete newSelectCells[key];
                            }
                        }
                    }

                    this.selectCells = newSelectCells;
                    this.$forceUpdate();
                    this.getSelectDate();
                }
            }
            this.moveStartDay = 0;
            this.moveStarTime = 0;
        },

        handleMouseMove(e) {
            if (this.moveStartEvent) {
                const box = this.$el.querySelector('#box');
                console.log(box);
                const dom = this.$el.querySelector('#box');
                const X = e.layerX - this.moveStartX;
                const Y = e.layerY - this.moveStartY;
                if (X >= 0 && Y >= 0) {
                    dom.style.left = `${this.moveStartX}px`;
                    dom.style.top = `${this.moveStartY}px`;
                    dom.style.width = `${X}px`;
                    dom.style.height = `${Y}px`;
                }
            }
        },

        getSelectDate() {
            const arr = this.weekDate.map((item, index) => {
                const dayData = {
                    label: item,
                    data: []
                };

                // 遍历24小时时间段
                for (let i = 1; i <= 24; i++) {
                    if (this.selectCells[`${index}_${i}`]) {
                        const startHour = (i - 1).toString().padStart(2, '0');
                        const endHour = i.toString().padStart(2, '0');
                        dayData.data.push([`${startHour}:00`, `${endHour}:00`]);
                    }
                }

                // 合并相邻时间段
                const mergedData = [];
                let currentRange = null;

                dayData.data.forEach(time => {
                    if (!currentRange) {
                        currentRange = [...time];
                    } else if (currentRange[1] === time[0]) {
                        currentRange[1] = time[1];
                    } else {
                        mergedData.push(currentRange);
                        currentRange = [...time];
                    }
                });

                if (currentRange) mergedData.push(currentRange);
                dayData.data = mergedData;

                return dayData;
            });

            this.selectDate = arr;
        },

        handleClear() {
            this.selectCells = {};
            this.getSelectDate();
            this.$forceUpdate();
        },

        getData() {
            return this.selectDate;
        }
    },
    computed: {
        displaySelectedRegions() {
            return this.selectedRegions.map(code =>
                this.getRegionPathByCodes([code]) // 复用你已有的方法
            ).filter(Boolean);
        }
    },

};
</script>

<style scoped>
.timeRange {
    user-select: none;
    position: relative;
    padding: 10px 0;

    .calendar {
        display: inline-block;
    }

    table {
        width: 100%;
        border-radius: 4px;
        border-spacing: 0;
        table-layout: fixed;
        border-collapse: collapse;

        thead {

            th,
            td {
                height: 30px;
            }

            th {
                padding: 5px 0;

            }

            .weekRow {
                width: 100px;
                min-width: 100px;
                padding: 20px 0
            }
        }

        td,
        th {
            outline: 0;
            border: 1px solid #E3E3E3;
            font-size: 12px;
            text-align: center;
            min-width: 11px;
            line-height: 1.6em;
            min-width: 24px;
        }

        tbody {
            position: relative;
            overflow: hidden;

            td {
                height: 20px !important;
            }
        }

        td.active {
            background: hsl(207, 97%, 49%);
        }
    }

    .table-core {
        line-height: 2.4em;
        border: 1px solid #E3E3E3;
        border-top: 0;
        overflow: hidden;
        padding: 10px;

        .clearfix {
            color: #8A8A8A;
            text-align: left;
            height: 22px;
            line-height: 22px;
            margin: 8px 0;
            display: flex;
            font-size: 12px;

            .clearBtn {
                cursor: pointer;
                color: #5775F9;
                font-size: 14px;
                margin-left: auto;
            }
        }

        ul {
            margin: 0;
            padding: 0;
            list-style: none;

            li {
                display: flex;
                align-items: center;
                line-height: 24px;
                margin-bottom: 8px;
                padding: 4px 0;

                label {
                    display: inline-block;
                    min-width: 60px;
                    color: #475569;
                    text-align: left;
                    font-weight: 500;
                    font-size: 13px;
                }

                span {
                    font-size: 13px;
                    background-color: #f1f5f9;
                    padding: 2px 8px;
                    border-radius: 4px;
                    margin-right: 6px;
                    color: #334155;

                    &::after {
                        display: none;
                    }
                }
            }
        }

    }

    #box {
        background: rgba(241, 1, 85, 0.4);
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
    }
}

#box {
    background: rgba(241, 1, 85, 0.4);
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
}




.checkIndex {
    padding: 20px;
    height: 600px;
    overflow: auto;
}

.checkView {
    margin-bottom: 20px;
    border: 1px solid #eee;
    padding: 10px;
    border-radius: 4px;
    display: flex;

}

.address {
    display: inline-block;
    margin-left: 10px;
}

.mobileCehck {
    margin-top: 10px;
}

.select-container {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
}

.plan-container {
    text-align: left;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 50px;
}

.el-form-item__label {
    margin-right: 50px;
}

.demo-ruleForm {
    max-width: 800px;
}

.el-form-item {
    margin-bottom: 22px;
}

.el-radio-group {
    margin-right: 15px;
}

.el-input {
    width: 280px;
}

.el-icon-info {
    color: #409EFF;
    cursor: pointer;
    font-size: 16px;
}

.el-button {
    margin-right: 10px;
}

.adgroup-container {
    padding: 20px;
    background-color: #fff;
}

.adgroup-form {
    max-width: 1200px;
    margin: 0 auto;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 10px;
    /* border-bottom: 1px solid #eee; */
}

.form-tip {
    font-size: 12px;
    color: #999;
    margin-top: 8px;
}

.media-specify-box,
.adslot-specify-box,
.region-custom-box,
.time-custom-box {
    margin-top: 15px;
    padding: 15px;
    background-color: #f9f9f9;
    border-radius: 4px;
}

.region-selection {
    margin-top: 15px;
    max-height: 300px;
    overflow-y: auto;
}

.region-item {
    margin-bottom: 10px;
}

.age-checkbox-group,
.phone-price-group,
.network-group {
    display: inline-block;
    margin-left: 15px;
}


.adgroup-item2 {
    color: #606266;
    line-height: 20px;
    font-size: 12px;
    border-left: 2px solid #606266;
    padding-left: 8px;
    font-family: PingFangSC-Regular;
    margin-top: 40px;
    margin-bottom: 40px;
}

.demo-ruleForm {
    max-width: 1000px;
}

.time-custom-box {
    margin-top: 15px;
    padding: 15px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background-color: #f5f7fa;
}

.form-tip {
    font-size: 12px;
    color: #999;
    margin-top: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/login/qttdxb.vue